/** @jsxImportSource theme-ui */
import { palette, highContrastPalette } from "../../styles";

export default Object.assign(palette, { highContrast: highContrastPalette });
